<template>
  <tr
    :key="item.id"
    :data-index="index"
    :class="{
      'active-item':
        selectedItemIds.indexOf(item.id) >= 0 ||
        (activeItem || {}).id === item.id,
    }"
    @click="onRowClick(item)"
  >
    <td
      v-for="(column, columnIndex) in columns"
      :key="column.key"
      class="text-ellipsis"
      :class="column.class"
      :align="column.align"
      :style="
        columnWidths[columnIndex]
          ? { width: `${columnWidths[columnIndex]}px` }
          : {}
      "
    >
      <ResourceListTitle
        v-if="column.key === 'subject'"
        :name="item.name"
        :subject="item.subject"
        external-link
        :link="
          $currentModule.getRoute('view-request', {
            params: { id: item.id },
          })
        "
        :created-at="item.createdAt"
      />
      <template v-else-if="column.key === 'sourceId'">
        <FlotoSourcePicker placeholder="---" :value="item.sourceId" disabled />
      </template>
      <template v-else-if="column.key === 'createdBy'">
        <FlotoRequesterPicker
          placeholder="---"
          :value="item.createdBy"
          disabled
        />
      </template>
      <template v-else-if="column.key === 'rating'">
        <RequestRatingView
          v-if="item.rating > 0"
          class="mx-1"
          :value="item.rating"
        />
      </template>
      <template v-else-if="column.key === 'lastResolvedTime'">
        {{ item.lastResolvedTime | datetime }}
      </template>
      <template v-else-if="column.key === 'lastClosedTime'">
        {{ item.lastClosedTime | datetime }}
      </template>
      <template v-else-if="column.key === 'approvalStatus'">
        <span v-if="item.approvalStatus">{{ $tc(item.approvalStatus) }}</span>
        <span v-else>---</span>
      </template>
      <template v-else-if="column.key === 'statusId'">
        <FlotoStatusPicker
          :module-name="$constants.REQUEST"
          placeholder="---"
          :value="item.statusId"
          disabled
        />
      </template>
      <template v-else-if="column.key === 'priorityId'">
        <FlotoPriorityPicker :value="item.priorityId" disabled />
      </template>
      <template v-else-if="column.key === 'categoryId'">
        <FlotoCategoryPicker
          :value="item.categoryId"
          :module-name="moduleName"
          placeholder="---"
          :as-input="false"
          disabled
        />
      </template>
      <template v-else-if="column.key === 'departmentId'">
        <FlotoDepartmentPicker
          :value="item.departmentId"
          :module-name="moduleName"
          disabled
        />
      </template>
      <template v-else-if="column.key === 'locationId'">
        <FlotoLocationPicker
          :value="item.locationId"
          :module-name="moduleName"
          placeholder="---"
          :as-input="false"
          disabled
        />
      </template>
      <template v-else-if="column.key === 'groupId'">
        <FlotoTechnicianGroupPicker :value="item.groupId" disabled />
      </template>
      <template v-else-if="column.key === 'createdAt'">
        {{ item.createdAt | datetime }}
      </template>
      <template v-else-if="column.key === 'urgencyId'">
        <FlotoUrgencyPicker :value="item.urgencyId" disabled />
      </template>
      <template v-else-if="column.key === 'technicianId'">
        <FlotoTechnicianPicker :value="item.technicianId" disabled />
      </template>
      <template v-else-if="column.key === 'impactId'">
        <FlotoImpactPicker :value="item.impactId" disabled />
      </template>
      <template v-else-if="/^\d+$/.test(column.key)">
        <ListTableCustomFieldValue
          :module-name="moduleName"
          :column="column"
          :item="item"
        />
      </template>
      <template v-else> Column Slot Missing! </template>
      <!-- custom field slots -->
    </td>
  </tr>
</template>

<script>
import ResourceListTitle from '@components/resource/resource-list-title'
import ListTableCustomFieldValue from '@components/table/list-table-custom-field-value.vue'
import RequestRatingView from '@modules/ticket/components/request-rating-view'

export default {
  name: 'RequestTableListRow',
  components: {
    ResourceListTitle,
    ListTableCustomFieldValue,
    RequestRatingView,
  },
  inheritAttrs: false,
  props: {
    index: { type: Number, required: true },
    columnWidths: { type: Array, required: true },
    moduleName: { type: String, required: true },
    item: { type: Object, required: true },
    selectedItemIds: { type: Array, required: true },
    activeItem: { type: Object, default: undefined },
    onRowClick: { type: Function, required: true },
    update: { type: Function, required: true },
    view: { type: String, default: 'list' },
    columns: { type: Array, required: true },
    toggleSelectItem: { type: Function, required: true },
  },
}
</script>
